import { useLocation, useNavigate } from "react-router-dom";
import { MessageCircle, Phone, CalendarCheck, Mail, Send } from "lucide-react";
import { useSettings } from "../lib/settings";
import { track } from "../lib/analytics";

export const WhatsAppFloat = () => {
  const { waLink } = useSettings();
  const wa = waLink();
  if (!wa) return null;
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { placement: "float" })}
      aria-label="Scrivici su WhatsApp"
      className="hidden lg:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
    >
      <MessageCircle size={26} />
    </a>
  );
};

export const MobileActionBar = () => {
  const { waLink, hasPhone, phoneHref, settings } = useSettings();
  const location = useLocation();
  const navigate = useNavigate();
  const isServicePage = location.pathname.startsWith("/servizi/");
  const wa = waLink();

  const primary = wa ? (
    <a
      data-testid="mobile-action-whatsapp"
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { placement: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-[#25D366]"
    >
      <MessageCircle size={20} />
      <span className="text-[11px] font-semibold">WhatsApp</span>
    </a>
  ) : (
    <a
      data-testid="mobile-action-email"
      href={settings?.email ? `mailto:${settings.email}` : "/contatti"}
      className="flex flex-col items-center gap-1 py-3 text-[#4B4B4B]"
    >
      <Mail size={20} />
      <span className="text-[11px] font-semibold">Email</span>
    </a>
  );

  const middle = isServicePage ? (
    <button
      data-testid="mobile-action-request"
      onClick={() => document.querySelector("#richiedi")?.scrollIntoView({ behavior: "smooth" })}
      className="flex flex-col items-center gap-1 py-3 text-[#4B4B4B]"
    >
      <Send size={20} />
      <span className="text-[11px] font-semibold">Richiedi</span>
    </button>
  ) : hasPhone ? (
    <a
      data-testid="mobile-action-call"
      href={phoneHref}
      onClick={() => track("phone_click", { placement: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-[#4B4B4B]"
    >
      <Phone size={20} />
      <span className="text-[11px] font-semibold">Chiama</span>
    </a>
  ) : (
    <button
      data-testid="mobile-action-contact"
      onClick={() => navigate("/contatti")}
      className="flex flex-col items-center gap-1 py-3 text-[#4B4B4B]"
    >
      <Phone size={20} />
      <span className="text-[11px] font-semibold">Contatti</span>
    </button>
  );

  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E7E7E7] shadow-[0_-4px_20px_rgba(0,0,0,0.08)] grid grid-cols-3"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {primary}
      {middle}
      <button
        data-testid="mobile-action-book"
        onClick={() => navigate(isServicePage ? `/prenota?servizio=${location.pathname.split("/")[2]}` : "/prenota")}
        className="flex flex-col items-center gap-1 py-3 bg-[#F26522] text-white"
      >
        <CalendarCheck size={20} />
        <span className="text-[11px] font-semibold">Prenota</span>
      </button>
    </div>
  );
};
